<template>
    <div class="fileeditor">
        <div class="fileeditor__wrap">
            <app-controlhead
                title="Dateiinformationen"
                :help="
                    (getFilemanagerFilesView === 'images'
                        ? $helpers.uiText('R002')
                        : $helpers.uiText('R004')) +
                        (getActiveFileeditorFile.folder === 'uploads'
                            ? ' ' + $helpers.uiText('R079')
                            : '')
                "
                :show-close="true"
                :show-remove="showRemove"
                :show-save="showSave"
                :show-global="false"
                @close="close"
                @remove="remove"
            ></app-controlhead>

            <div class="fileeditor__content">
                <ul class="fileeditor__properties">
                    <li
                        v-if="fileIsImage(getActiveFileeditorFileId)"
                        class="fileeditor__property fileeditor__image-preview-wrap"
                    >
                        <img
                            v-bind:src="generateMediaUrl({ id: getActiveFileeditorFileId, w: 600 })"
                            alt=""
                            class="fileeditor__image-preview"
                        />
                        <a
                            :href="generateMediaUrl({ id: getActiveFileeditorFileId })"
                            target="_blank"
                            class="fileeditor__image-preview-link"
                            >Auge</a
                        >
                    </li>
                    <li class="fileeditor__property fileeditor__property--filename">
                        <app-text
                            label="Dateiname"
                            :value="getActiveFileeditorFile.filename"
                            :disabled="true"
                            :maxlength="255"
                        ></app-text>
                    </li>
                    <li class="fileeditor__property fileeditor__property--group">
                        <div class="fileeditor__property-grouped">
                            <app-text
                                label="Dateityp"
                                :value="getFileExtension(getActiveFileeditorFileId)"
                                :disabled="true"
                                :maxlength="255"
                            ></app-text>
                        </div>
                        <div class="fileeditor__property-grouped">
                            <app-text
                                label="Dateigröße"
                                :value="Math.round(getActiveFileeditorFile.filesize / 1024) + ' kb'"
                                :disabled="true"
                                :maxlength="255"
                            ></app-text>
                        </div>
                        <div
                            v-if="fileIsImage(getActiveFileeditorFileId)"
                            class="fileeditor__property-grouped fileeditor__property-grouped--dimensions"
                        >
                            <app-text
                                label="Bildauflösung"
                                :value="
                                    getActiveFileeditorFile.image_width +
                                        ' x ' +
                                        getActiveFileeditorFile.image_height +
                                        ' px'
                                "
                                :disabled="true"
                                :maxlength="255"
                            ></app-text>
                        </div>
                    </li>
                    <li class="fileeditor__property fileeditor__property--alt-tag">
                        <app-text
                            label="Alt-Tag"
                            :data-source="'tecpage.files.' + getActiveFileeditorFileId + '.alt'"
                            :disabled="getActiveFileeditorFile.folder !== 'uploads'"
                            :maxlength="255"
                        ></app-text>
                    </li>
                    <li class="fileeditor__property fileeditor__property--copyright">
                        <app-text
                            label="Copyright"
                            :data-source="
                                'tecpage.files.' + getActiveFileeditorFileId + '.copyright'
                            "
                            required
                            :disabled="getActiveFileeditorFile.folder !== 'uploads'"
                            :maxlength="255"
                        ></app-text>
                    </li>
                    <li
                        v-if="getActiveFileeditorFile.folder === 'uploads'"
                        class="fileeditor__property fileeditor__property--copyright-note"
                    >
                        <p v-html="$helpers.uiText('R073')"></p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="fileeditor__buttons">
            <button
                v-on:click.prevent="
                    getActiveFileeditorFile.folder === 'uploads' ? saveAndClose() : close()
                "
                v-html="
                    getActiveFileeditorFile.folder === 'uploads'
                        ? 'Übernehmen &amp; Schließen'
                        : 'Schließen'
                "
                :disabled="buttonDisabled"
                class="button button--icon-checkmark"
            ></button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import Text from '@/components/fields/simple/Text.vue';
import Controlhead from '@/components/assorted/Controlhead';

export default {
    data() {
        return {};
    },
    components: {
        'app-text': Text,
        'app-controlhead': Controlhead
    },
    methods: {
        ...mapActions([
            'routeRemoveQuery',
            'forgetDifferInRoute',
            'saveAllData',
            'deleteInFilemanager',
            'removeFile',
            'updateFile'
        ]),
        async save() {
            await this.forgetDifferInRoute(this.openedRoute);
            await this.updateFile(this.getActiveFileeditorFileId);
            await this.saveAllData();
        },
        async saveAndClose() {
            await this.save();
            await this.close();
        },
        async close() {
            await this.routeRemoveQuery(['fileeditor', 'fileeditor_file_id']);
        },
        async remove() {
            await this.removeFile({
                id: this.getActiveFileeditorFileId,
                confirm: true,
                save: true,
                route: true
            });
        }
    },
    computed: {
        ...mapGetters([
            'differHasChangesInRoute',
            'differHasInvalidFieldsInRoute',
            'getActiveFileeditorFileId',
            'getActiveFileeditorFile',
            'getFileExtension',
            'fileIsImage',
            'generateMediaUrl',
            'isFileDeletable',
            'getFilemanagerFilesView'
        ]),
        showSave() {
            return (
                this.differHasChangesInRoute(this.openedRoute) &&
                !this.differHasInvalidFieldsInRoute(this.openedRoute)
            );
        },
        buttonDisabled() {
            return this.differHasInvalidFieldsInRoute(this.openedRoute);
        },
        showRemove() {
            return this.isFileDeletable(this.getActiveFileeditorFileId);
        }
    },
    created() {},
    mixins: [OpenedRouteMixin]
};
</script>
